module.exports = __webpack_public_path__ + "assets/img/quick-start-light-en.7b4bc07b.png";